const KEY = "ycs_recently_viewed";

export function pushRecentlyViewed(id) {
  if (!id) return;
  try {
    let arr = JSON.parse(localStorage.getItem(KEY)) || [];
    arr = [id, ...arr.filter((x) => x !== id)].slice(0, 12);
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {}
}

export function getRecentlyViewed(excludeId) {
  try {
    const arr = JSON.parse(localStorage.getItem(KEY)) || [];
    return excludeId ? arr.filter((x) => x !== excludeId) : arr;
  } catch {
    return [];
  }
}
